<section *ngIf="!hideError && errorFormList && errorFormList.length > 0">
  <mat-error>
    <strong>Bitte beheben Sie die Fehler im Formular um mit dieser Aktion fortzufahren</strong>
  </mat-error>
</section>

<div class="button-container">
  <app-custom-button *ngIf="actionReject" [title]="textReject" (onClick)="reject()"></app-custom-button>
  <app-custom-button [title]="textConfirm" (onClick)="accept()"></app-custom-button>
</div>
